import UtmMakrsPresenter from "../components/utm-marks/presenter/utm-marks.js";

const utmMarksComponent = new UtmMakrsPresenter();
utmMarksComponent.init();
